import Vue from "vue";
import Vuex from "vuex";
import app from "./modules/app";
import account from "./modules/account";
import dashboard from "./modules/dashboard";
import safe from "./modules/safe";
import formsData from "./modules/formsData";
import upload from "./modules/upload";
import tuspload from "./modules/tuspload";
import queue from "./modules/queue";
import support from "./modules/support";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    app,
    account,
    dashboard,
    safe,
    upload,
    tuspload,
    queue,
    formsData,
    support,
  },
  strict: debug,
});
